import { useState, useEffect, useCallback } from "react";
import client from "../lib/api";

// Per-CRM editable city list, backed by the shared /meta/locations store
// (same source PropertyDetail uses, so cities stay consistent everywhere).
export function useCities() {
  const [cities, setCities] = useState([]);

  const reload = useCallback(async () => {
    try {
      const r = await client.get("/meta/locations");
      setCities(r.data.cities || []);
    } catch (e) { console.error("City list load failed", e); }
  }, []);

  useEffect(() => { reload(); }, [reload]);

  const addCity = useCallback(async (name) => {
    const r = await client.post("/meta/locations", { kind: "city", name });
    setCities(r.data.cities || []);
    return r.data.cities;
  }, []);

  const removeCity = useCallback(async (name) => {
    const r = await client.post("/meta/locations/delete", { kind: "city", name });
    setCities(r.data.cities || []);
    return r.data.cities;
  }, []);

  return { cities, addCity, removeCity, reload };
}
